import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';

import { createMetaItem } from './createMetaVariables';

export function title(...parts: (string | undefined)[]) {
  return {
    title: parts.filter(Boolean).join(' | ') || 'Jane Premium',
  };
}

export function getMetaTitle(
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) {
  return title(createMetaItem(customSEOPage?.title, metaVariables));
}
